import { useCallback, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'

import {
  BuilderMenu,
  BuilderMenuItem,
  COND_FEATURE_FLAG_ALL,
  ConditionFeatureFlag,
  ConditionValue,
} from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { VisibilitySelector } from '@/components/BehaviourV2/VisibilitySelector'

/**
 * MenuItemBehaviorAccordion is a function component that provides an interface for editing the behavior of a menu item in a builder.
 */
function MenuItemBehaviorAccordion({
  menu,
  menuIdx,
  menuItem: curMenuItem,
  menuItemIdx,
}: {
  menuIdx: number
  menu: BuilderMenu
  menuItem: BuilderMenuItem
  menuItemIdx: number
}) {
  const { updateMenu } = useAppBuilderContext()
  const [localValue, setLocalValue] = useState<ConditionValue | null>(curMenuItem.visibility ?? null)

  useEffect(() => {
    setLocalValue(curMenuItem.visibility ?? null)
  }, [curMenuItem.visibility])

  const handleVisibilityChange = useCallback(
    (nextValue: ConditionValue | null) => {
      setLocalValue(nextValue)

      updateMenu(menuIdx, (prev) => {
        if (nextValue === null) {
          prev.items[menuItemIdx].visibility = undefined as any
        } else {
          prev.items[menuItemIdx].visibility = nextValue
        }
      })
    },
    [menuIdx, menuItemIdx, updateMenu]
  )

  return (
    <AccordionItem itemId='menu-item-behavior' title={<Trans>Behavior</Trans>}>
      <VisibilitySelector
        id={`${menu.id}-${curMenuItem.id}-visibility`}
        value={localValue}
        featureFlags={COND_FEATURE_FLAG_ALL & ~ConditionFeatureFlag.CurrentRow}
        onChange={handleVisibilityChange}
      />
    </AccordionItem>
  )
}

export default MenuItemBehaviorAccordion
